<template>
  <div class="baidumap-options-style"> </div>
</template>

<script>
export default {
  name: "baidumap-options-style",
  components: {},
  props: {
    options: Object
  },
  computed: {},
  data() {
    return {
      styleImgs: []
    }
  },
  mounted() {},
  methods: {}
}
</script>
